// extracted by mini-css-extract-plugin
export default {"errorInfo":"JS56OA1NPVie7ovyjlPR","userInfo":"U5DKkWJzv3BJXYi3gSoD"};